import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { dspxSorter } from "../../../helpers/dspx-sort";
import { documentsConstants } from "../constants/documents.constants";
import sortConstants from "../constants/sortConstants";
import { usePrevious } from '../../../hooks/usePrevious';

const useSorter = (sortObj, documents) => {
	const [sortColumn, setSortColumn] = useState();
	const [sortParam, setSortParam] = useState(null);
	const [sortOrder, setSortOrder] = useState();
  const [sorter, setSorter] = useState();
  const dispatch = useDispatch();
  const prevDocs = usePrevious(documents);

  useEffect(() => {
    if (
      sortOrder !== sortObj?.order ||
      sortColumn !== sortObj?.columnKey ||
      prevDocs !== documents
    ) {
      if (!documents.length) return;
      const columnKey = sortObj.column && sortObj.column.key;
      const sp = columnKey ? sortConstants[columnKey] : sortConstants.id;
      const st =
        dspxSorter["sorter" + sp + (sortObj.order === "ascend" ? "Asc" : "Desc")];
      documents.sort(st);
      dispatch({ type: documentsConstants.UNSET_RESORT });
      setSorter(() => st);
      setSortColumn(sortObj.columnKey);
      setSortOrder(sortObj.order);
      setSortParam(sp);
    }
  
  }, [sortObj, documents]);

	
	return [sortParam, sortOrder, sorter];
};

export default useSorter;
